import React from "react";
import { IStoreSearchFilters } from "tsi-common-react/src/apps/retail/models.interfaces";
import { IMiles, isoMiles } from "tsi-common-react/src/models/nominals";

import { IFilterChangeHandler } from "../models.interfaces";
import { LocatorFilterPopover } from "./LocatorFilters_Popover";

interface IProps {
    filterValues: IStoreSearchFilters;
    onChange: IFilterChangeHandler;
}

interface IState {
    filterValueInRedux: IMiles;
    value: IMiles;
}

// TODO(ssr, MEDIUM 5 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 5/10 due to getDerivedStateFromProps lifecycle, state synchronization with props, refs, and filter submission logic.
export class DistanceFilter extends React.Component<IProps, IState> {
    state: IState = {
        filterValueInRedux: this.props.filterValues.distance,
        value: this.props.filterValues.distance,
    };

    private readonly distanceOptions = [10, 20, 30, 40, 50, 75, 100];
    private readonly filterElem = React.createRef<{
        onRequestClose: () => void;
    }>();

    static getDerivedStateFromProps(
        props: IProps,
        state: IState,
    ): IState | null {
        if (props.filterValues.distance !== state.filterValueInRedux) {
            return {
                filterValueInRedux: props.filterValues.distance,
                value: props.filterValues.distance,
            };
        }
        return null;
    }

    private readonly onChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.setState({
            value: isoMiles.wrap(parseInt(event.currentTarget.value, 10)),
        });
    };

    private readonly onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        this.props.onChange({
            distance: this.state.value,
        });
        if (this.filterElem.current) {
            this.filterElem.current.onRequestClose();
        }
    };

    private readonly onAfterClose = () => {
        // Revert filter back to the state in Redux
        this.setState((s) => {
            return {
                ...s,
                value: s.filterValueInRedux,
            };
        });
    };

    render() {
        return (
            <LocatorFilterPopover
                ref={this.filterElem}
                id="distance"
                // TODO(i18n): Use t with interpolation: t`${this.props.filterValues.distance} miles`
                labelText={`${this.props.filterValues.distance} miles`}
                onAfterClose={this.onAfterClose}
            >
                <form
                    className="filters__dropdown filters__dropdown--distance"
                    onSubmit={this.onSubmit}
                >
                    <fieldset>
                        {/* TODO(i18n): Use t tagged template: {t`Change the distance search radius.`} */}
                        <legend className="filters__instruct">
                            Change the distance search radius.
                        </legend>
                        <div className="form__field filters__inputs">
                            <label htmlFor="bh-sl-maxdistance"></label>
                            <select
                                id="bh-sl-maxdistance"
                                className="form__select"
                                name="bh-sl-maxdistance"
                                // TODO(i18n): Use t tagged template: aria-label={t`Max Distance`}
                                aria-label="Max Distance"
                                onChange={this.onChange}
                                value={isoMiles.unwrap(this.state.value)}
                            >
                                {this.distanceOptions.map((opt) => {
                                    return (
                                        <option key={opt} value={opt}>
                                            {/* TODO(i18n): Use t with interpolation: {t`${opt} miles`} */}
                                            {opt} miles
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="filters__actions sl-search__actions">
                            <input
                                className="filters__button button"
                                type="submit"
                                // TODO(i18n): Use t tagged template: aria-label={t`Submit`}
                                aria-label="Submit"
                            />
                        </div>
                    </fieldset>
                </form>
            </LocatorFilterPopover>
        );
    }
}
